import { render, staticRenderFns } from "./Farmacia.vue?vue&type=template&id=d0038fac&scoped=true"
import script from "./Farmacia.vue?vue&type=script&lang=js"
export * from "./Farmacia.vue?vue&type=script&lang=js"
import style0 from "./Farmacia.vue?vue&type=style&index=0&id=d0038fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0038fac",
  null
  
)

export default component.exports